import {FeatureGate, ProjectFeatureFlag} from 'common/report/constants';
import type {CurrentProject} from 'common/report/model-resources/projects';

export function hasAccessToFeatureFlagsApp(currentProject?: CurrentProject): boolean {
  if (!currentProject) {
    return false;
  }
  return (
    currentProject.hasFeatureFlag(ProjectFeatureFlag.FeatureFlagsApp) ||
    (currentProject.getFeatureGate(FeatureGate.FeatureFlagsApp) &&
      mixpanel?.flags?.get_variant_value_sync(`feature-flags-rollout`))
  );
}
